module.exports = __webpack_public_path__ + "img/slidebar-bom-bg.920b8f04.png";